import React, { use, useEffect } from 'react';
import { Mail } from 'lucide-react';
import { sendEmail } from '../utils/api';

/**
 * The Contact Us Page component, providing contact information and a simulated email form.
 */
const ContactUsPage = () => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_TITLE} - Contact Us`;
  }, []);

  const handleSendEmail = () => {
    document.getElementById("email-status").innerText = "Sending...";
    document.getElementById("email-status").style.color = "black";

    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const message = document.getElementById("message").value;

    if (!name || !email || !message) {
      document.getElementById("email-status").innerText = "Please fill in all fields.";
      document.getElementById("email-status").style.color = "red";
      return;
    }

    if (!validateEmail(email)) {
      document.getElementById("email-status").innerText = "Invalid email format.";
      document.getElementById("email-status").style.color = "red";
      return;
    }

    const htmlMessage = message.replace(/\n/g, '<br/>'); // Convert newlines to <br> for HTML formatting

    sendEmail(name, email, htmlMessage)
      .then((data) => {
        document.getElementById("email-status").innerText = "Email sent successfully!";
        document.getElementById("email-status").style.color = "green";
      })
      .catch((error) => {
        document.getElementById("email-status").innerText = "Error sending email.";
        document.getElementById("email-status").style.color = "red";
      });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  return (
    <section id="contact-us" className="bg-card-background p-6 md:p-8 rounded-xl shadow-lg mb-8">
      <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6 border-b-2 border-border-light pb-2 flex items-center">
        <Mail className="w-7 h-7 mr-2" /> Contact Us
      </h2>
      <div className="text-text-dark space-y-4 text-lg">
        <p>
          We'd love to hear from you! If you have any questions, feedback, or inquiries, please feel free to reach out.
          You can send us an email directly by clicking the button below.
        </p>
        <div className="max-w-md mx-auto bg-background-light p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-primary-dark mb-4">Send us an Email</h3>
          {/* Simple form for visual representation - actual email sending via mailto */}
          <div className="mb-4">
            <label htmlFor="name" className="block text-text-dark text-sm font-bold mb-2">Your Name:</label>
            <input
              type="text"
              id="name"
              className="shadow appearance-none border border-border-light rounded w-full py-2 px-3 text-text-dark leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Full name"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="block text-text-dark text-sm font-bold mb-2">Your Email:</label>
            <input
              type="email"
              id="email"
              className="shadow appearance-none border border-border-light rounded w-full py-2 px-3 text-text-dark leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Your email address"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="message" className="block text-text-dark text-sm font-bold mb-2">Message:</label>
            <textarea
              id="message"
              rows="5"
              className="shadow appearance-none border border-border-light rounded w-full py-2 px-3 text-text-dark leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Your message here..."
            ></textarea>
          </div>
          <button
            onClick={handleSendEmail}
            className="bg-accent-main hover:bg-accent-hover text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 flex items-center justify-center text-xl w-full"
          >
            <Mail className="w-6 h-6 mr-2" /> Send Email
          </button>
          <p id="email-status" className="text-sm text-text-muted mt-4 text-center">

          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactUsPage;
